export default __webpack_public_path__ + "css/orbit-app-build.css";